import useAppMutation from 'hooks/useAppMutation';
import API from 'services/API';
import { authEndpoints } from 'services/API.constants';

interface Parameters {
  onSuccess: () => void;
  onError: () => void;
}

const useForgotPasswordSubmit = ({ onSuccess, onError }: Parameters) => {
  const { mutate: submitResetPassword } = useAppMutation(
    ['resetPassword'],
    (email: string) => API.post(authEndpoints.resetPassword, { email }),
    {
      onSuccess,
      onError,
    },
  );

  return { submitResetPassword };
};

export default useForgotPasswordSubmit;
